import { message } from "antd";
import { setCookie, deleteCookie, getCookie } from "cookies-next";

export const setUserData = (data, reload = true) => {
  setCookie("HireSide_Employers_AccessToken", data.token, {  maxAge: 60 * 60 * 24 * 7 });
  setCookie("HireSide_Employers_UserInfo", JSON.stringify(data.userInfo), {  maxAge: 60 * 60 * 24 * 7 });
  localStorage.setItem("HireSide_Employers_AccessToken", data.token);
  localStorage.setItem(
    "HireSide_Employers_UserInfo",
    JSON.stringify(data.userInfo)
  );
  if (reload) {
    signIN();
  }
};

export const isUserLogin = () => {
  return localStorage.getItem("HireSide_Employers_AccessToken") !== null;
};

export const getUserToken = () => {
  return localStorage.getItem("HireSide_Employers_AccessToken");
};

export const setUserToken = (data) => {
  setCookie("HireSide_Employers_AccessToken", data.token, {  maxAge: 60 * 60 * 24 * 7 });
  localStorage.setItem("HireSide_Employers_AccessToken", data.token);
};

export const getUserInfo = () => {
  let data;
  try {
    data = JSON.parse(localStorage.getItem("HireSide_Employers_UserInfo"));
  } catch (error) {
    message.error("Somthing went wrong");
    data = {};
  }
  return data;
};

export const getUserInfoCookie = () => {
  let data
  try {
    data = getCookie("HireSide_Employers_UserInfo");
    if (!data) {
      return {};
    }
    return JSON.parse(data);
  } catch (error) {
    message.error("Something went wrong");
    return {};
  }
};

export const setUserInfo = (data, reload = false) => {
  localStorage.setItem("HireSide_Employers_UserInfo", JSON.stringify(data));
  if (reload) {
    signIN();
  }
};

export const singOut = () => {
  localStorage.removeItem("HireSide_Employers_AccessToken");
  localStorage.removeItem("HireSide_Employers_UserInfo");
  deleteCookie("HireSide_Employers_AccessToken");
  deleteCookie("HireSide_Employers_UserInfo");
  deleteCookie("employerRoles");
  deleteCookie("companyCode");
  deleteCookie("companies");
  deleteCookie("JobStatusFilters");
  deleteCookie("CandidateCheckboxFilters");
  deleteCookie("companyLogo");
};

export const signIN = async () => {
  const LoginEvent = new Event("employersStateChanges");
  window.dispatchEvent(LoginEvent);
};

export const employerSignOutEvent = async () => {
  const reauth = new Event("reauth");
  window.dispatchEvent(reauth);
};
